import type { AreaCatalog } from '../area';
import type { modules as en } from '../en/modules';

export const modules = {
  'modules.resources.label': 'Ressourcen',
  'modules.resources.description': 'Geplanter Einsatz: Aufwand, eine grobe Schätzung und Budget.',
  'modules.resources.allocation.label': 'Einsatz',
  'modules.resources.allocation.help':
    'Der geplante Aufwand der Zuständigen für diese Aufgabe, in der gewählten Einheit. FTE ist der Anteil einer Vollzeitstelle; über 1,0 FTE heißt überlastet.',
  'modules.resources.allocationUnit.label': 'Einheit des Einsatzes',
  'modules.resources.allocationCadence.label': 'Rhythmus des Einsatzes',
  'modules.resources.allocationCadence.help':
    'Einmalig oder wiederkehrend (pro Woche / pro Monat).',
  'modules.resources.estimate.label': 'Schätzung',
  'modules.resources.estimate.help': 'Eine grobe Größe für die Planung, keine Buchung.',
  'modules.resources.estimateUnit.label': 'Einheit der Schätzung',
  'modules.resources.budget.label': 'Budget',
  'modules.resources.budget.help': 'Für diese Aufgabe geplantes Geld, einmalig oder wiederkehrend.',
  'modules.resources.budgetCurrency.label': 'Währung',
  'modules.resources.budgetCadence.label': 'Rhythmus des Budgets',
  'modules.checklist.label': 'Checkliste',
  'modules.checklist.description':
    'Die Punkte der Liste unter der Aufgabe, jeder mit einem Kästchen zum Abhaken.',
  'modules.schedule.label': 'Zeitplan',
  'modules.schedule.description':
    'Wann das läuft: Beginn und Ende (ein Datum oder an eine andere Aufgabe gebunden) und eine Dauer.',
  'modules.schedule.startTime.label': 'Beginn',
  'modules.schedule.startTime.help':
    'Wann das beginnt (ein Datum oder jede Genauigkeit: 2026-W24, 2026-Q3).',
  'modules.schedule.startAnchor.label': 'Bezug des Beginns',
  'modules.schedule.startAnchor.help': 'Beginn relativ zu einer anderen Aufgabe, plus ein Abstand.',
  'modules.schedule.startOffset.label': 'Abstand zum Beginn',
  'modules.schedule.startOffsetUnit.label': 'Einheit des Abstands zum Beginn',
  'modules.schedule.endTime.label': 'Ende',
  'modules.schedule.endTime.help':
    'Bis wann das gebraucht wird. Nach dem Ende gilt die Aufgabe als überfällig.',
  'modules.schedule.endAnchor.label': 'Bezug des Endes',
  'modules.schedule.endAnchor.help': 'Ende relativ zu einer anderen Aufgabe, plus ein Abstand.',
  'modules.schedule.endOffset.label': 'Abstand zum Ende',
  'modules.schedule.endOffsetUnit.label': 'Einheit des Abstands zum Ende',
  'modules.schedule.duration.label': 'Dauer',
  'modules.schedule.duration.help': 'Wie lange das dauert, in der gewählten Einheit.',
  'modules.schedule.durationUnit.label': 'Einheit der Dauer',
  'modules.schedule.cadence.label': 'Rhythmus',
  'modules.schedule.cadence.help':
    'Der erwartete Takt: wie oft sich das bewegen soll (z. B. jede Woche). Laufende Arbeit bleibt etwa einen Takt lang ohne Bewegung gesund.',
  'modules.schedule.cadenceUnit.label': 'Einheit des Rhythmus',
} as const satisfies AreaCatalog<typeof en>;
